import { createApp } from 'vue/dist/vue.esm-bundler.js';
import PhotoBooth from './components/photo-booth.vue';

function NewApp() {
  let app = createApp({})
	  app.component("photo-booth", PhotoBooth);

  // Common
  return app;
}

let lastApp: any = null;

export function initVue(){
  if (window.vm) {
    lastApp?.unmount()
    lastApp = null;
  }
  let app = NewApp();
  window.vm = app.mount("[data-behavior='vue']")
  lastApp = app;
}